import { Stack, Card, Typography, Box, IconButton } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link, useParams } from 'react-router';
import { HeaderBreadcrumbs, ScreenError, ScreenWrap } from '../../components';
import { Api } from '../../api';

/** The weeks of one program; opening one shows its content (ProgramWeekScreen). */
export default function ProgramWeeksScreen() {
  const { programId } = useParams();
  const programApi = Api.Program.useReadItem(programId ?? '');
  const weeksApi = Api.ProgramWeek.useReadCollectionAdminList({
    program: `/programs/${programId}`,
  });

  if (programApi.error) return <ScreenError {...programApi} />;
  if (weeksApi.error) return <ScreenError {...weeksApi} />;

  const weeks =
    weeksApi.data?.member?.slice().sort((a, b) => a.number - b.number) || [];

  return (
    <ScreenWrap>
      <Stack gap={3}>
        <HeaderBreadcrumbs
          title={programApi.data?.title ?? 'Program'}
          items={[{ name: 'Program Content', url: '/program' }]}
        />
        <Box
          sx={{
            width: '100%',
          }}
        >
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(6, 1fr)',
              gap: 2,
            }}
          >
            {weeks.map((week) => (
              <Card
                key={week.id}
                component={Link}
                to={`/program/${week.number}/${week.id}`}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  px: 3,
                  py: 2,
                  minWidth: 120,
                  boxShadow: 'none',
                  border: '1px solid #F1F1F4',
                  borderRadius: 2,
                  background: '#fff',
                  textDecoration: 'none',
                }}
              >
                <Typography
                  sx={{
                    color: '#1A1A1A',
                    fontWeight: 500,
                    fontSize: 16,
                  }}
                >
                  Week {week.number}
                </Typography>
                <IconButton>
                  <ArrowForwardIcon color="primary" />
                </IconButton>
              </Card>
            ))}
          </Box>
        </Box>
      </Stack>
    </ScreenWrap>
  );
}
